import { formatDateTime, toYMD } from "../../../../../common/helpers/time";
function AdminInstructorsEditCertificationsController(
  $state,
  $stateParams,
  UsersModel,
  FlashService,
  UsermetaModel,
) {
  const vm = this;
  vm.today = formatDateTime(new Date(), "M/DD/YYYY");

  vm.editCertification = editCertification;

  init();

  function init() {
    UsersModel.getInstructorByID($stateParams.instructorId).then((response) => {
      response.usermeta.certificate.expiration_date = formatDateTime(
        new Date(response.usermeta.certificate.expiration_date),
        "MM/DD/YYYY",
      );
      response.usermeta.certificate.issue_date = formatDateTime(
        new Date(response.usermeta.certificate.issue_date),
        "MM/DD/YYYY",
      );
      vm.instructor = response;
      vm.certificate = {
        number: vm.instructor.usermeta.certificate.number,
        issue_date: vm.instructor.usermeta.certificate.issue_date,
        expiration_date: vm.instructor.usermeta.certificate.expiration_date,
      };
    });
  }

  function editCertification(isValid) {
    vm.submitted = true;

    if (isValid) {
      const issue_date = toYMD(new Date(vm.certificate.issue_date));
      const expiration_date = toYMD(new Date(vm.certificate.expiration_date));
      const usermeta = {
        user_id: vm.instructor.id,
        meta_key: "certificate",
        meta_value: {
          number: vm.certificate.number,
          issue_date: issue_date,
          expiration_date: expiration_date,
        },
      };

      UsermetaModel.update(usermeta).then((response) => {
        FlashService.setMessage({
          type: "success",
          message: response.message,
        });
        vm.submitted = false;
        $state.go("drivecoach.admin.instructors.view", {
          instructorId: response.usermeta.user_id,
        });
      });
    } else {
      FlashService.setMessage({
        type: "error",
        message: "Please fill the form.",
      });
    }
  }
}
AdminInstructorsEditCertificationsController.$inject = [
  "$state",
  "$stateParams",
  "UsersModel",
  "FlashService",
  "UsermetaModel",
];

export default AdminInstructorsEditCertificationsController;

